import { Modal, Box, Stack, Typography, Button, useTheme, Link } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useTranslation } from 'react-i18next'
import { ReactComponent as Demo } from '../../../assets/walkthrough/demo.svg'

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
}

const FsDemoAccountModal = ({
  isOpen,
  setIsOpen,
  app = 'fs',
}: {
  isOpen: boolean
  setIsOpen?: (isOpen: boolean) => void
  app?: string
}) => {
  const { t } = useTranslation()
  const theme = useTheme()

  return (
    <Modal
      open={isOpen}
      onClose={() => setIsOpen && setIsOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Stack direction="row" justifyContent="space-between">
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography id="modal-modal-title" variant="h1" component="h2" mb={4} fontWeight="bold">
              {t('demo.account.title')}
            </Typography>
            <Demo />
            <Typography id="modal-modal-description" sx={{ mt: 6, textAlign: 'center' }}>
              {t('demo.account.description.1')}{' '}
              {app === 'fs' ? (
                <Link href="mailto:support.fs@ines-analytics.com">
                  support.fs@ines-analytics.com
                </Link>
              ) : (
                <Link href="mailto:support.pt@ines-analytics.com">
                  support.pt@ines-analytics.com
                </Link>
              )}{' '}
              {t('demo.account.description.2')}
            </Typography>
            <Button
              variant="contained"
              sx={{
                mt: 4,
                width: 200,
              }}
            >
              <a
                href={
                  app === 'fs'
                    ? 'mailto:support.fs@ines-analytics.com'
                    : 'mailto:support.pt@ines-analytics.com'
                }
                style={{ color: 'white', textDecoration: 'none' }}
              >
                {t('demo.account.button.1')}
              </a>
            </Button>
            <Button
              variant="outlined"
              sx={{
                mt: 2,
                width: 200,
              }}
              onClick={() => setIsOpen && setIsOpen(false)}
            >
              {t('demo.account.button.2')}
            </Button>
          </Box>
          {setIsOpen && (
            <Box onClick={() => setIsOpen(false)} sx={{ cursor: 'pointer' }}>
              <CloseIcon />
            </Box>
          )}
        </Stack>
      </Box>
    </Modal>
  )
}

export default FsDemoAccountModal
